import { useMutation } from '@tanstack/react-query';

import {
  requestResetCode,
  verifyResetCode,
  confirmReset,
} from '@/api/adapters/reset-password';

/**
 * Step 1 — Request password-reset verification code for the given email.
 * Returns the raw useMutation so callers attach their own onSuccess / onError.
 */
export function useRequestResetCode() {
  return useMutation<void, Error, string>({
    mutationFn: (email) => requestResetCode(email),
  });
}

/**
 * Step 2 — Verify the 6-digit OTP code.
 * Returns the raw useMutation so callers attach their own onSuccess / onError.
 */
export function useVerifyResetCode() {
  return useMutation<{ resetToken: string }, Error, { email: string; code: string }>({
    mutationFn: ({ email, code }) => verifyResetCode(email, code),
  });
}

/**
 * Step 3 — Set a new password with the reset token from step 2.
 * Returns the raw useMutation so callers attach their own onSuccess / onError.
 */
export function useConfirmReset() {
  return useMutation<
    void,
    Error,
    { resetToken: string; password: string; confirmPassword: string }
  >({
    mutationFn: ({ resetToken, password, confirmPassword }) =>
      confirmReset(resetToken, password, confirmPassword),
  });
}
